import type { ReleaseBulkAction } from '@planuze/admin-contracts';
import { DESTRUCTIVE_RELEASE_BULK_ACTIONS, RELEASE_BULK_ACTIONS } from '@planuze/admin-contracts';
import { Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@planuze/ui';
import { useState } from 'react';
import { useReleasesAdminContent } from '../../content/sections/releases-admin.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

/* Barra de ação em lote da tela de versões (ADR-0809), molde do `BulkActionBar` de publishers
   (ADR-0471): só aparece com seleção, e a confirmação vive na page — aqui não se aplica nada. */

export function ReleaseBulkBar({
  selectedCount,
  promotionBlocked,
  busy,
  onApply,
  onClear,
}: {
  readonly selectedCount: number;
  readonly promotionBlocked: boolean;
  readonly busy: boolean;
  readonly onApply: (action: ReleaseBulkAction) => void;
  readonly onClear: () => void;
}) {
  const [action, setAction] = useState<ReleaseBulkAction>('promote');
  const copy = useReleasesAdminContent().bulkBar;
  if (selectedCount === 0) return null;
  const destructive = DESTRUCTIVE_RELEASE_BULK_ACTIONS.includes(action);
  const promotionAction = action === 'promote' || action === 'promoteMandatory';
  const applyBlocked = promotionBlocked && promotionAction;
  return (
    <BulkSelectionBar
      selectedLabel={copy.selectedCount(selectedCount)}
      clearLabel={copy.clearSelection}
      busy={busy}
      onClear={onClear}
    >
      <Select value={action} onValueChange={(v) => setAction(v as ReleaseBulkAction)}>
        <SelectTrigger className="h-9 w-60" aria-label={copy.actionAriaLabel}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {RELEASE_BULK_ACTIONS.map((a) => (
            <SelectItem key={a} value={a}>
              {copy.actionLabels[a]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {applyBlocked && (
        <span className="max-w-72 text-xs text-warning">{copy.promotionStorageUnavailable}</span>
      )}
      {/* `destructive` já no gatilho: o botão que abre a confirmação de apagar não pode parecer
          igual ao que promove. A confirmação em si (com a contagem) é da page. */}
      <Button
        size="sm"
        variant={destructive ? 'destructive' : 'default'}
        disabled={busy || applyBlocked}
        onClick={() => onApply(action)}
      >
        {copy.apply}
      </Button>
    </BulkSelectionBar>
  );
}
